import { useTheme } from "@mui/material";

const useNavigationHeaderStyles = () => {
  const theme = useTheme();
  return {
    inputField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "0px",
        height: "48px",
        marginBottom: "20px",
        marginTop: "20px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "0px",
      },
      "& .MuiInputBase-input::placeholder": {
        fontFamily: "Lexend",
        fontSize: "14px",
        lineHeight: "17.5px",
      },
    },
    appBar: {
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 2,
      boxShadow: "none",
      background: "transparent",
      position: "sticky",
    },
    toolbar: (isScrolled) => ({ 
      transition: "box-shadow 0.3s ease-in-out",
      boxShadow: isScrolled ? `0px 0px 10px 0px ${theme.palette.customColor.secondaryThird}` : "none",
      height: "74px",
      display: "flex",
      backgroundColor: "white",
      padding: {
        md: "0 6% !important",
        sm: "0 5% !important",
        xs: "0 22px !important",
      },
      justifyContent: "center",
    }),
    toolbarContent: {
      maxWidth: "1650px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headingFont: {
      fontSize: "14px",
    },
    buttonGroup: {
      display: "flex",
      gap: { lg: "16px", xs: "12px" },
      alignItems: "center",
      minWidth: { lg: "350px", xs: "auto" },
    },
    mobileLayout: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "100vh",
    },
    hidden: {
      display: { lg: "block", xs: "none" },
      fontSize: "14px",
    },
    logo: {
      display: { lg: "none", xs: "block" },
      color: theme.palette.primary.main,
      marginTop: "5px",
    },
    drawerButtonGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      alignItems: "center",
    },
    drawerItemList: {
      width: "100vw",
      display: "flex",
      flexDirection: "column",
    },
    drawerItem: {
      margin: "0px 4%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      width: "92%",
    },
    drawerItemLi: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "18px",
      textTransform: "uppercase",
    },
    drawerItem1: {
      margin: "0px 4%",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: 400,
      cursor: "pointer",
      width: "92%",
    },
    border: {
      borderTop: `1px solid ${theme.palette.customColor.secondaryThird}`,
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    border1: {
      borderTop: `1px solid ${theme.palette.customColor.secondaryThird}`,
      paddingTop: "20px",
    },
    border2: {
      borderBottom: `1px solid ${theme.palette.customColor.secondaryThird}`,
      paddingBottom: "20px",
    },
    border3: {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    
    link: {
      color: theme.palette.primary.main,
      textDecoration: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "0 4px",
      // fontSize: "14px",
      // fontWeight: "400",
    },
    links: {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
    iconBackground: {
      fontSize: "22px",
      color: theme.palette.primary.main,
    },
    text: {
      fontSize: "12px",
      fontWeight: 300,
      lineHeight: "18px",
      color: theme.palette.customColor.secondarySecond,
      marginTop: "8px",
    },
    newUser: {
      margin: "16px auto",
      textTransform: "none",
      color: theme.palette.primary.main,
    },
    iconClass: {
      position: "absolute",
      left: "0",
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      padding: "20px 0px",
      marginBottom: "20px",
    },
    greycolor: {
      color: theme.palette.customColor.grey,
    },
    fullWidth: {
      width: "100%",
    },
    siteLogo: {
      height: "20px",
      marginTop: { xs: "3px", sm: "0" },
    },
    logoHeight: {
      height: "20px",
    },
    bottomSpace32: {
      marginBottom: "32px",
    },
    bottomSpace20: {
      marginBottom: "20px",
    },
    userName: {
      fontFamily: "Lexend",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "18px",
      color: theme.palette.primary.main,
    },
    profileButton: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      cursor: "pointer",
    },
    dropdownMenu: {
      position: "absolute",
      top: "54px !important",
      right: "6.4% !important",
      left: "auto !important",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "6px 2px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      width: "219px",
      borderRadius: "0px !important",

    },
    dropDownRow1: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      backgroundColor: "transparent !important",
    },
    dropDownRow2: {
      marginTop: "10px",
      backgroundColor: "transparent !important",
    },
    dropDownRow3: {
      backgroundColor: "transparent !important",
      marginBottom: "24px",
    },
    dropDownField:{
      fontFamily: "Lexend",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "17.5px",
      color: "#050505",

    },
   
    dorpDownUserName: {
      fontFamily: "Lexend",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "17px",
      color: theme.palette.primary.main,
      display: "-webkit-box",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "150px",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      whiteSpace: "normal",
      marginBottom: "4px",
    },
    dorpDownViewProfile: {
      fontFamily: "Lexend",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "17.5px",
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
    iconProfile: {
      fontSize: "40px",
      color: theme.palette.primary.main,
    },
    bagIcon: {
      position: "relative",
    },
    bagCount: {
      position: "absolute",
      top: "-5px",
      right: "-6px",
      backgroundColor: "#A78D78",
      color: "white",
      borderRadius: "50%",
      width: "16px",
      height: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "10px",
    }
  };
};

export default useNavigationHeaderStyles;
